import { Check } from "lucide-react";
import { CARD_TEMPLATES, CardRenderer } from "@/features/cards/templates/cardBackgrounds";

export function TemplatePicker({ value, identity, onChange }) {
  return (
    <div role="radiogroup" aria-label="Card background" className="grid grid-cols-[repeat(auto-fill,132px)] gap-3">
      {CARD_TEMPLATES.map((t) => {
        const active = t.id === value;
        return (
          <button
            key={t.id}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(t.id)}
            data-testid={`card-template-option-${t.id}`}
            className="group text-left"
          >
            <span className={`block rounded-lg p-1 ring-1 transition-shadow ${active ? "ring-2 ring-foreground" : "ring-border group-hover:ring-foreground/40"}`}>
              <span className="mwc-thumb block">
                <span className="mwc-thumb-inner block">
                  <CardRenderer templateId={t.id} identity={identity} idPrefix={`thumb-${t.id}`} />
                </span>
              </span>
            </span>
            <span className="mt-2 flex items-center gap-1.5 text-xs">
              {active && <Check className="h-3.5 w-3.5" />}
              <span className={active ? "font-medium" : "text-muted-foreground"}>{t.name}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
